<template>
  <d-card class="card-small">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ $t("dashboard.toptemplates") }}</h6>
    </d-card-header>

    <d-card-body class="p-0">
      <!-- Top Templates List Group -->
      <d-list-group flush class="list-group-small">
        <d-list-group-item>
          <span>{{ $t("dashboard.templatename") }}</span>
          <span class="float-right">{{ $t("dashboard.totalclicks") }}</span>
        </d-list-group-item>
        <div v-if="getCampaignStats.templates">
          <d-list-group-item
            v-for="template in getCampaignStats.templates"
            :key="template.name"
            class="d-flex px-3"
          >
            <span class="text-semibold text-fiord-blue">{{ template.name }}</span>
            <span class="ml-auto text-right text-semibold text-reagent-gray">{{ template.count }}</span>
          </d-list-group-item>
        </div>
      </d-list-group>
    </d-card-body>
  </d-card>
</template>

<script>
import { mapGetters } from "vuex";
import { CAMPAIGN_GET_STATS } from "@/store/types";

export default {
  name: "ao-top-referrals",
  computed: {
    ...mapGetters(["isCampaignLoading", "getCampaignStats"])
  }
};
</script>
